<template>
	<div v-if="isVisible" class="popup-container">
		<div class="card white popup">
			<h2>{{ title }}</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="name">Nom du logement</label>
					<input type="text" id="name" v-model="property.name" />
				</div>
				<div class="form-control type">
					<label for="typ">Type</label>
					<input type="text" id="typ" v-model="property.typ" disabled />
				</div>
			</div>
			<div class="form-group">
				<div class="form-control address">
					<label class="info-label" for="address">Adresse</label>
					<input type="text" id="address" v-model="property.address" disabled />
				</div>
				<div class="form-control fiscal">
					<label for="fiscal_number">Numéro fiscal</label>
					<input type="text" id="fiscal_number" v-model="property.fiscal_number" />
				</div>
			</div>

			<h2>Fichiers du logement</h2>

			<div class="uploaded-files">
				<div v-for="(files, type) in groupedLastFiles" :key="type">
					<h3>{{ type }}</h3>
					<div v-for="file in files" :key="file.name" class="file-entry">
						<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
						<i v-else class="bi bi-file-image-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<i class="file-icon bi bi-download" @click="downloadLastFile(file.ID)"></i>
						<i class="file-icon bi bi-eye-fill" @click="openLastPreview(file.ID)"></i>
						<i class="file-icon bi bi-trash-fill" @click="openPopup(file.ID)"></i>
					</div>
				</div>
			</div>

			<h2 v-if="Object.keys(groupedFiles).length">Fichiers à envoyer</h2>

			<div class="uploaded-files">
				<div v-for="(files, type) in groupedFiles" :key="type">
					<h3>{{ type }}</h3>
					<div v-for="file in files" :key="file.name" class="file-entry">
						<i v-if="file.name.toLowerCase().endsWith('.pdf')" class="bi bi-file-pdf-fill"></i>
						<i v-else class="bi bi-file-image-fill"></i>
						<p class="file-name">{{ file.name }}</p>
						<p class="file-action" @click="openPreview(file)">Voir</p>
						<p>|</p>
						<p class="file-action" @click="deleteFile(file)">Supprimer</p>
					</div>
				</div>
			</div>
			<div v-if="!dpeFilesExist || !auditFilesExist" class="form-control">
				<label v-if="!dpeFilesExist" for="dpe" class="button outline dotted normal">Ajouter un DPE</label>
				<input type="file" name="dpe" id="dpe" class="hidden-input" multiple @change="handleDPEUpload" />
				<label v-if="!auditFilesExist" for="audit" class="button outline dotted normal">Ajouter un audit
					énergétique</label>
				<input type="file" name="audit" id="audit" class="hidden-input" multiple @change="handleAuditUpload" />
			</div>
			<div class="form-control">
				<button class="button outline normal" @click="openUploadFile">Ajouter d'autres diagnostics</button>
			</div>

			<h2>Propriétaire</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="email">Email</label>
					<input type="text" id="email" v-model="property.email" disabled />
				</div>
			</div>
			<input type="hidden" v-model="property.id_ban" name="id_ban" />
			<input type="hidden" v-model="property.lat" name="lat" />
			<input type="hidden" v-model="property.lng" name="lng" />

			<div v-if="errorMessage" class="message">{{ errorMessage }}</div>
			<div class="popup-actions">
				<button type="submit" class="button fill normal" @click="confirmAction">{{ confirmButtonText }}</button>
				<button type="submit" class="button fill normal" @click="cancelAction">{{ cancelButtonText }}</button>
			</div>
		</div>
		<FichierSelectPopup :isVisible="showUploadFile" title="Ajouter un fichier" @confirm1="handleFileUpload"
			@cancel1="closeUploadFile"> </FichierSelectPopup>
		<ConfirmationPopup :isVisible="showPopup" title="Confirmer la suppression"
			message="Êtes-vous sûr de vouloir supprimer ce fichier ?" @confirm="deleteLastFile" @cancel="closePopup">
		</ConfirmationPopup>
	</div>
</template>

<script>
import FichierSelectPopup from "@/franchise-pages/FichierSelectPopup.vue";
import ConfirmationPopup from "@/components/ConfirmationPopup";

export default {
	name: "ModifierCIL",
	props: {
		isVisible: Boolean,
		title: String,
		cil: Object,
		confirmButtonText: {
			type: String,
			default: "Mettre à jour",
		},
		cancelButtonText: {
			type: String,
			default: "Annuler",
		},
	},
	components: {
		FichierSelectPopup,
		ConfirmationPopup,
	},
	data() {
		return {
			property: {
				name: "",
				typ: "",
				address: "",
				fiscal_number: "",
				files: [],
				email: "",
			},
			showUploadFile: false,
			fileToDelete: "",
			showPopup: false,
			errorMessage: "",
			uploadedFiles: [],
		};
	},
	watch: {
		cil: {
			immediate: true,
			handler(newValue) {
				this.property.name = newValue.name || "";
				this.property.typ = newValue.type || "";
				this.property.address = newValue.address || "";
				this.property.fiscal_number = newValue.fiscal_number || "";
				this.property.files = newValue.files || [];
				this.property.email = newValue.userEmail || "";
			},
		},
	},
	methods: {
		async fetchCIL() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "admin/cil/" + this.cil.ID, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) {
					window.location.href = "/login";
				} else {
					let cil = { ...data };
					this.property.name = cil.name;
					this.property.typ = cil.type;
					this.property.address = cil.address;
					this.property.fiscal_number = cil.fiscal_number;
					this.property.files = cil.files;

				}
			} catch (error) {
				this.message = "Une erreur est survenue.";
			}
		},
		async confirmAction() {
			try {
				const formData = new FormData();
				formData.append("propID", this.cil.ID);
				formData.append("name", this.property.name);
				formData.append("fiscal_number", this.property.fiscal_number);

				this.uploadedFiles.forEach((file) => formData.append(file.selectedType, file.blob, file.name));

				const response = await fetch(process.env.VUE_APP_API_URL + "admin/cil/edit", { method: "POST", credentials: "include", body: formData, });

				if (response.ok) return this.cancelAction();

				const errorData = await response.json();
				this.errorMessage = errorData.error || "Erreur lors de la soumission des données. Veuillez réessayer.";
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			}
		},
		checkUploadFile(type) {
			return ["image/jpeg", "image/png", "application/pdf"].includes(type);
		},
		handleDPEUpload(event) {
			this.addFilesWithType(event.target.files, "DPE");
		},
		handleAuditUpload(event) {
			this.addFilesWithType(event.target.files, "Audit énergétique");
		},
		addFilesWithType(files, type) {
			const validFiles = Array.from(files).filter((file) => this.checkUploadFile(file.type));
			const uploadFiles = validFiles.map((file) => ({
				name: file.name,
				size: file.size,
				type: file.type,
				blob: file,
				selectedType: type,
			}));
			this.uploadedFiles = this.uploadedFiles.concat(uploadFiles);
		},
		handleFileUpload(files) {
			this.uploadedFiles = this.uploadedFiles.concat(files);
			this.showUploadFile = false;
		},
		cancelAction() {
			this.uploadedFiles = [];
			this.errorMessage = "";
			this.$emit("cancel2");
		},
		openPopup(fileId) {
			this.fileToDelete = fileId;
			this.showPopup = true;
		},
		closePopup() {
			this.showPopup = false;
		},
		async deleteLastFile() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "admin/fichier/delete/" + this.fileToDelete, { method: "GET", credentials: "include", });
				if (!response.ok) return alert("Erreur : " + this.fileToDelete);

				this.closePopup();
				this.fileToDelete = "";
				this.fetchCIL();
			} catch (error) {
				console.log("Une erreur est survenue lors de la requête.");
			}
		},
		openUploadFile() {
			this.showUploadFile = true;
		},
		closeUploadFile() {
			this.showUploadFile = false;
		},
		openLastPreview(fileId) {
			const url = process.env.VUE_APP_API_URL + "admin/read/" + fileId;
			window.open(url, "_blank");
		},
		downloadLastFile(fileId) {
			const url = process.env.VUE_APP_API_URL + "admin/download/" + fileId;
			window.open(url, "_blank");
		},
		openPreview(file) {
			if (!file) return;
			if (file.type.startsWith("image/")) {
				const reader = new FileReader();
				reader.onload = (e) => {
					const image = new Image();
					image.src = e.target.result;
					const previewWindow = window.open("", "_blank");
					previewWindow.document.write(image.outerHTML);
				};
				reader.readAsDataURL(file.blob);
			} else if (file.type === "application/pdf") {
				const pdfUrl = URL.createObjectURL(file.blob);
				const previewWindow = window.open(pdfUrl, "_blank");
				previewWindow.document.title = file.name;
			} else {
				this.errorMessage = "Seuls les fichiers JPEG, PNG et PDF sont autorisés.";
			}
		},
		deleteFile(file) {
			this.uploadedFiles = this.uploadedFiles.filter((f) => f !== file);
		},
	},
	computed: {
		groupedFiles() {
			const grouped = {};
			this.uploadedFiles.forEach((file) => {
				if (!grouped[file.selectedType]) {
					grouped[file.selectedType] = [];
				}
				grouped[file.selectedType].push(file);
			});
			return grouped;
		},
		groupedLastFiles() {
			const grouped = {};
			this.property.files.forEach((file) => {
				if (!grouped[file.type]) grouped[file.type] = [];
				grouped[file.type].push(file);
			});
			return grouped;
		},
		dpeFilesExist() {
			return this.uploadedFiles.some((file) => file.selectedType === "DPE");
		},
		auditFilesExist() {
			return this.uploadedFiles.some((file) => file.selectedType === "Audit énergétique");
		},
	},
};
</script>

<style scoped>
.form-control.type,
.form-control.fiscal {
	flex: 0.5;
}

.form-control.address {
	position: relative;
}

.uploaded-files {
	margin-bottom: 25px;
}

.uploaded-files>div:not(:first-child) {
	margin-top: 10px;
}

.hidden-input {
	width: 1px;
	height: 1px;
	padding: 0;
	opacity: 0;
}
</style>
